// extracted by mini-css-extract-plugin
export var completionBody = "_l2-2";
export var completionCard = "_l2-0";
export var completionFooter = "_l2-3";
export var completionTitle = "_l2-1";